import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientRegistrationNewFileEntity } from './client-registration-new-file.entity';
import { ClientEntity } from './client.entity';

@Index('client_registration_new_fk_client__id_fk', ['fkClientId'], {})
@Entity('client_registration_new')
export class ClientRegistrationNewEntity extends BaseEntity {
	@Column('varchar', { name: 'name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('varchar', { name: 'ownerName', nullable: true, length: 255 })
	public ownerName!: string | null;

	@Column('varchar', { name: 'buyerName', nullable: true, length: 255 })
	public buyerName!: string | null;

	@Column('varchar', { name: 'address1', nullable: true, length: 255 })
	public address1!: string | null;

	@Column('varchar', { name: 'address2', nullable: true, length: 255 })
	public address2!: string | null;

	@Column('varchar', { name: 'city', nullable: true, length: 255 })
	public city!: string | null;

	@Column('varchar', { name: 'state', nullable: true, length: 255 })
	public state!: string | null;

	@Column('varchar', { name: 'zip', nullable: true, length: 255 })
	public zip!: string | null;

	@Column('varchar', { name: 'email', nullable: true, length: 255 })
	public email!: string | null;

	@Column('varchar', { name: 'phone', length: 255 })
	public phone!: string;

	@Column('varchar', { name: 'secondaryPhone', nullable: true, length: 255 })
	public secondaryPhone!: string | null;

	@Column('varchar', { name: 'fax', nullable: true, length: 255 })
	public fax!: string | null;

	@Column('int', { name: 'fk_client__id', nullable: true, unsigned: true })
	public fkClientId!: number | null;

	@Column('varchar', { name: 'status', length: 255, default: () => "'1'" })
	public status!: string;

	@OneToMany(() => ClientEntity, (client) => client.fkClientRegistrationNew, {})
	public clients!: Array<ClientEntity>;

	@ManyToOne(() => ClientEntity, (client) => client.clientRegistrationNews, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@OneToMany(
		() => ClientRegistrationNewFileEntity,
		(clientRegistrationNewFile) =>
			clientRegistrationNewFile.fkClientRegistrationNew,
		{},
	)
	public clientRegistrationNewFiles!: Array<ClientRegistrationNewFileEntity>;
}
